import axios from 'axios'

let API_URL;
if (process.env.NODE_ENV === "development") {
    API_URL = process.env.API_URL || 'http://localhost:3000'
} else {
    API_URL = process.env.API_URL || 'https://richendanse-api-studio-uni.herokuapp.com'
}
// API_URL = process.env.API_URL || 'https://richendanse-api-studio-uni.herokuapp.com'
// API_URL = process.env.API_URL || 'http://localhost:3000'

export default axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': 'Bearer ' + localStorage.token
    }
})
